import React from 'react';
import { useSelector } from 'react-redux';
import { selectRole, selectRoute, selectRouteSimple, selectUlogovan } from '../redux/selectors';
import StranaWelcome from './StranaWelcome';
// import LoginForm from './LoginForm';
import StranaDevPanel from './StranaDevPanel';
/*
import StranaPrimeri from './StranaPrimeri';
import StranaDizajniraj from './StranaDizajniraj';
import StranaPrezentacija from './StranaPrezentacija';
import StranaPrezentacija2 from './StranaPrezentacija2';
import StranaPlan from './StranaPlan';
import StranaPrimerHi from './StranaPrimerHi';
import StranaDokumentacija from './StranaDokumentacija';
import StranaDokumentacijaTermovent from './StranaDokumentacijaTermovent';
import StranaDocsStandardi from './StranaDocsStandardi';
*/
// import StranaExport from './StranaExport';
// import StranaTerNarudzbe from './StranaTerNarudzbe';
// import StranaEditor from './StranaEditor';
/*
import StranaImport from './StranaImport';
import StranaImportOstalo from './StranaImportOstalo';
import StranaBiblioteka from './StranaBiblioteka';
import StranaBibliotekaPolja from './StranaBibliotekaPolja';
import StranaBibliotekaParametara from './StranaBibliotekaParametara';
import StranaDokumentacijaUputstvo from './StranaDokumentacijaUputstvo';
import StranaPrezentacija2022 from './StranaPrezentacija2022';
*/
// import StranaTerTok from './StranaTerTok'; // NOVO 2023
// import StranaAdminPanel from './StranaAdminPanel';
/*
import StranaExportCNC from './StranaExportCNC';
import StranaDokumentacijaTestiranje from './StranaDokumentacijaTestiranje';
import StranaDokumentacijaURazvoju from './StranaDokumentacijaURazvoju';
*/
import { routeDataGet } from '../utils/routes-helper';


export const RouterSimple = (props) => {
  // let route = props.routeSimple.route;
  const ulogovan = useSelector(selectUlogovan);
  const role = useSelector(selectRole);
  const routeSimple = useSelector(selectRouteSimple);
  let route = routeSimple.route;
  const routeData = routeDataGet(route);
  let route_for_second_screen = false;
  if (routeData.second_screen === true) {
    route_for_second_screen = true;
  }


  //
  let jsx = null;
  let is_ter_tok_page = false;
  if (route === 'HOME') {
    jsx = <StranaWelcome />
  } else if (route === 'LOGIN') {
    // jsx = <LoginForm />


  } else if (route === 'EDITOR_V1') {
    // jsx = <StranaEditorStari />
  } else if (route === 'TER_NARUDZBE') {
    // jsx = <StranaTerNarudzbe />
    if (ulogovan === true) {
      is_ter_tok_page = true;
      // jsx = <StranaTerTok route={route} />
    } else {
      jsx = <StranaWelcome />
    }
  } else if (route === 'EDITOR') {
    // jsx = <StranaEditor />
    if (ulogovan === true) {
      is_ter_tok_page = true;
      // jsx = <StranaTerTok route={route} />
    } else {
      jsx = <StranaWelcome />
    }
  } else if (route === 'EXPORT') {
    // jsx = <StranaExport />
    if (ulogovan === true) {
      is_ter_tok_page = true;
      // jsx = <StranaTerTok route={route} route_params={routeSimple.route_params} />
    } else {
      jsx = <StranaWelcome />
    }


  /*
  } else if (route === 'EXPORT_CNC') {
    jsx = <StranaExportCNC />
  } else if (route === 'BIBLIOTEKA') {
    jsx = <StranaBiblioteka />
  } else if (route === 'BIBLIOTEKA_PARAMETARA') {
    jsx = <StranaBibliotekaParametara />
  } else if (route === 'BIBLIOTEKA_POLJA') {
    jsx = <StranaBibliotekaPolja />
  } else if (route === 'IMPORT') {
    jsx = <StranaImport />
  } else if (route === 'IMPORTOSTALO') {
    jsx = <StranaImportOstalo />


  } else if (route === 'SCENARIO_2') {
    // jsx = <StranaScenario2 />
  } else if (route === 'PRIMERI') {
    jsx = <StranaPrimeri />
  } else if (route === 'DIZAJNIRAJ') {
    jsx = <StranaDizajniraj />
  } else if (route === 'PRIMER_HIJERARHIJE') {
    jsx = <StranaPrimerHi />
  } else if (route === 'PREZENTACIJA') {
    jsx = <StranaPrezentacija />
  } else if (route === 'PREZENTACIJA2') {
    jsx = <StranaPrezentacija2 />
  } else if (route === 'PREZENTACIJA2022') {
    jsx = <StranaPrezentacija2022 />
  } else if (route === 'PLAN') {
    jsx = <StranaPlan />
  } else if (route === 'DOKUMENTACIJA_UPUTSTVO') {
    jsx = <StranaDokumentacijaUputstvo />
  } else if (route === 'DOKUMENTACIJA') {
    jsx = <StranaDokumentacija />
  } else if (route === 'DOKUMENTACIJA_TERMOVENT') {
    jsx = <StranaDokumentacijaTermovent />
  } else if (route === 'DOCS_STANDARDI') {
    jsx = <StranaDocsStandardi />
  } else if (route === 'DOKUMENTACIJA_TESTIRANJE') {
    jsx = <StranaDokumentacijaTestiranje />
  } else if (route === 'DOKUMENTACIJA_U_RAZVOJU') {
    jsx = <StranaDokumentacijaURazvoju />
    */



    /*
    } else if (route === 'ADMIN_PANEL') {
      jsx = <StranaAdminPanel />
    } else if (route === 'ADMIN_USERS') {
      jsx = <StranaAdminKorisnici />
    } else if (route === 'ADMIN_TER_COMORDER') {
      jsx = <StranaAdminTerNarudzbe />
    } else if (route === 'ADMIN_TER_COMORDITEM') {
      jsx = <StranaAdminTerStavkeNarudzbe />
    } else if (route === 'ADMIN_LIB_VIRTEL_PARAMS') {
      jsx = <StranaAdminLibVirtelParams />
    } else if (route === 'ADMIN_LIB_MATERIJAL_LIM') {
      jsx = <StranaAdminLibMaterijalLim />
    } else if (route === 'ADMIN_LIB_CPARAMS') {
      jsx = <StranaAdminLibTerCparams />
    } else if (route === 'ADMIN_LIB_CNC_S4_TEMPLATE') {
      jsx = <StranaAdminLibCNCProgramS4Template />
    } else if (route === 'ADMIN_LIB_DOCUMENT') {
      jsx = <StranaAdminLibDocument />
    } else if (route === 'ADMIN_LIB_TER_CONST') {
      jsx = <StranaAdminLibTerConst />
    } else if (route === 'ADMIN_DINAMICKAF') {
      jsx = <StranaAdminDinamickaFunkcionalnost />
    */



  } else if (route === 'DEVPANEL') {
    jsx = <StranaDevPanel />



  } else if (route_for_second_screen) {
    jsx = 'SECOND SCREEN';
  } else {
    jsx = 'ROUTE NOT FOUND';
    // console.log('ROUTE NOT FOUND', route);
  }

  let jsx2 = jsx;
  if (is_ter_tok_page === true) {
  } else {
    // all other pages wrapped with pad
    jsx2 = (
      <div className="pad">
        {jsx}
      </div>
    );
  }

  return (
    <>
      {jsx2}
    </>
  );
};

export default RouterSimple;